import * as angular from 'angular';
import { uiViewInnerComponent } from './ui-view-inner.component';

export const uiViewInnerModule = angular.module('uiViewInner', [])
	.component('uiViewInner', uiViewInnerComponent)
	.name;
